import e from"react";var r=function(r){var t=r.children,n=r.renderContent;return e.createElement(e.Fragment,null,n&&t)};export{r as default};
